import { loadTossPayments, ANONYMOUS } from '@tosspayments/tosspayments-sdk';

export { ANONYMOUS };

const TOSS_CLIENT_KEY = process.env.NEXT_PUBLIC_TOSS_CLIENT_KEY!;

export async function initTossWidgets(customerKey: string = ANONYMOUS) {
  const tossPayments = await loadTossPayments(TOSS_CLIENT_KEY);
  const widgets = tossPayments.widgets({ customerKey });
  return widgets;
}

/**
 * 결제 주문명 정리 — 토스는 orderName 100자 초과 시 결제 요청을 거부한다.
 * 견적 물품명에 고객이 붙여넣은 설명/링크가 그대로 들어오면 쉽게 100자를 넘겨 결제가 막혔다.
 * 줄바꿈 정리 → (길면) 링크 제거 → 그래도 길면 80자로 자름.
 */
export const ORDER_NAME_MAX_LENGTH = 80;

export function sanitizeOrderName(name: string, maxLength = ORDER_NAME_MAX_LENGTH): string {
  const collapse = (s: string) => s.replace(/\s+/g, ' ').trim();

  let result = collapse(name);
  if (result.length > maxLength) {
    // 설명에 섞여 들어온 URL 부터 걷어내면 물품명이 남는다 (URL 뿐이면 원문 유지)
    const withoutUrls = collapse(result.replace(/https?:\/\/\S+/gi, ''));
    if (withoutUrls) result = withoutUrls;
  }
  if (result.length > maxLength) {
    result = `${result.slice(0, maxLength - 1).trimEnd()}…`;
  }
  return result || '배송 서비스';
}
